module.exports = __webpack_public_path__ + "img/hr-puberty-decal-25.4b9eeee7.png";